import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddCategory, ICategory } from "../../Category.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useEditCategory = (educationId: string, onEditComplete?: () => void) => {
  const [formData, setFormData] = useState<IAddCategory>({
    category: "",
    icon: null
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [education, setEducation] = useState<ICategory | null>(null);
  const [iconPreview, setIconPreview] = useState<string | null>(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.getAllCategories}/${educationId}`,
      }); 
      setEducation(response);
      setFormData(response);
      setIconPreview(response?.icon || "");
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch category data");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { id, type, value } = e.target;
    if (type === "file") {
      const files = (e.target as HTMLInputElement).files;
      if (files && files.length > 0) {
        setFormData(prev => ({
          ...prev,
          [id]: files[0],
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const handleSubmit: SubmitHandler<IAddCategory> = async (data) => {
    setLoading(true);
    const formDataToSend = new FormData();
    
    // Always send the category name
    formDataToSend.append('category', data.category);
    
    // Only append the icon if a new file was selected
    if (formData.icon) {
      formDataToSend.append('imageUrl', formData.icon);
    }

    console.log(formData.icon)
     
    try {
      const response = await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.getAllCategories}/${educationId}`,
        data: formDataToSend,
        headers: { "Content-Type": "multipart/form-data" },
      });
      
      toast.success("Category updated successfully");
      // Call the callback to close the edit modal instead of navigating
      if (onEditComplete) {
        onEditComplete();
      }
    } catch (error) {
      toast.error("Error updating category");
      console.error("Error updating category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Call the callback to close the edit modal instead of reloading
    if (onEditComplete) {
      onEditComplete();
    }
  };

  useEffect(() => {
    fetchData();
  }, [educationId]);

  return {
    loading,
    formData,
    education,
    handleChange,
    handleSubmit,
    handleCancel,
    iconPreview,
    setIconPreview 
  };
};

export default useEditCategory;